import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useEffect, useState } from 'react';

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Small delay to prevent flash when navigating between protected routes
    const timer = setTimeout(() => {
      setShouldRender(true);
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  // Show loading state briefly to prevent flash
  if (!shouldRender || isLoading) {
    return null;
  }

  if (!isAuthenticated()) {
    // User is not authenticated, redirect to login
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render the protected content
  return children;
}

export default ProtectedRoute;
